import { useTranslations } from 'next-intl';
import { Address } from 'components/pcc-components';
import { replaceTokensWithComponents } from '@cat-ecom/common/utils/stringUtils';
import { LocationAddress } from 'services/location/types';
import { getSeoUrl } from 'utils/links';
import { useEsiteCtx } from 'services/esite/context';
import { useParams } from 'next/navigation';
import { contactDealerCommonContent } from 'components/contact-your-dealer/utils';
import styles from './contact-dealer-mobile-drawer-content.module.scss';
import cx from 'classnames';

interface ContactDealerMobileDrawerContentProps {
  dealerAddress: LocationAddress;
  locale: string;
  isCustomerSupportEnabled?: boolean;
}

export default function ContactDealerMobileDrawerContent({
  dealerAddress,
  locale,
  isCustomerSupportEnabled = false
}: Readonly<ContactDealerMobileDrawerContentProps>) {
  const { catalogId, langId, storeId } = useEsiteCtx();
  const params = useParams();
  const esiteUrl = getSeoUrl(params);

  const t = useTranslations();
  const textContainerClassName = 'cat-u-theme-typography-footnote-bold mb-3';
  const titleClassName = styles['contact-dealer-mobile-drawer-content__title'];
  const linkClassName = styles['contact-dealer-mobile-drawer-content__link'];
  const textClassName = styles['contact-dealer-mobile-drawer-content__text'];

  const {
    dealerPhone,
    dealerEmail,
    hasAddressInfo,
    addressObj,
    contactFormLink
  } = contactDealerCommonContent({
    dealerAddress,
    catalogId,
    langId,
    storeId,
    esiteUrl,
    isCustomerSupportEnabled
  });

  return (
    <div className={styles['contact-dealer-mobile-drawer-content']}>
      {!!dealerPhone && (
        <div className={textContainerClassName}>
          <span className={titleClassName}>{t('CONTACT_DEALER_CALL')}</span>
          <br />
          <a className={linkClassName} href={`tel:${dealerPhone}`}>
            {dealerPhone}
          </a>
        </div>
      )}
      {!!dealerEmail && (
        <div className={textContainerClassName}>
          <span className={titleClassName}>{t('EMAIL_US')}</span>
          <br />
          <a className={linkClassName} href={`mailto:${dealerEmail}`}>
            {dealerEmail}
          </a>
        </div>
      )}
      {hasAddressInfo && (
        <span className={textContainerClassName}>
          <span className={titleClassName}>{t('CONTACT_DEALER_VISIT')}</span>
          <span className={textClassName}>
            <Address locale={locale} address={addressObj} />
          </span>
        </span>
      )}
      <div className={cx(textContainerClassName, 'mb-0 mt-4')}>
        <span className={textClassName}>
          {replaceTokensWithComponents(
            t('CONTACT_DEALER_CONTACT_FORM', { '0': '{0}' }),
            <a className={linkClassName} href={contactFormLink} target="_blank">
              {t('CONTACT_FORM')}
            </a>
          )}
        </span>
      </div>
    </div>
  );
}
